import React from "react";
import Header from "../../components/HeaderNew";
import { Button } from "@material-ui/core";
import Footer from "../FooterNew";
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Helmet } from "react-helmet";

import { Section } from "react-scroll-section";
import NewHead from "../landing/NewHead";
import ServiceFooter from "../ServiceFooter";

function Cex() {
  const processes_feture = {
    arrows: true,
    dots: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 3,
          infinite: true,
          dots: false,
          arrow: false,
          autoplay: true,
          autoplaySpeed: 2000,
        },
      },

      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
          dots: false,
          autoplay: true,
          arrow: false,
          autoplaySpeed: 2000,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
          arrow: false,
          dots: false,
          autoplay: true,
          autoplaySpeed: 2000,
        },
      },
    ],
  };

  return (
    <main className="">
      <header>
        {/* <Header /> */}
        <NewHead />
      </header>
      <Helmet>
        <title>
          Central Bank Digital Currency Development Company - Beleaf
          Technologies
        </title>

        <meta
          name="title"
          content="Central Bank Digital Currency Development Company"
        />
        <meta
          name="description"
          content=" Levelup your financial ecosystem with our Central Bank Digital Currency development expertise. As a leading company, we specialize in creating secure and scalable CBDC solutions developed to your needs. Trust us to navigate the digital currency landscape and shape the future of your central bank's digital presence."
        />

        <meta
          property="og:title"
          content="Central Bank Digital Currency Development Company - Beleaf Technologies"
        />
        <meta property="og:site_name" content="Beleaf Technologies" />

        <link
          rel="canonical"
          href="https://www.beleaftechnologies.com/central-bank-digital-currency-development-company"
        />
      </Helmet>
      <main className="cbdc_main">
        <section className="cbdc_bannersec d-flex align-items-center">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 d-flex align-items-center">
                <div className="cbdc_bannersec_content d-flex flex-column">
                  <h1 className="mb-0">
                    Central Bank
                    <br />
                    Digital Currency
                    <br />
                    Development Company
                  </h1>
                  <p className="mb-0 cbdc_p ">
                    We bring unparalleled expertise to transform the landscape
                    of digital currencies. Contact us today to transform your
                    nation's digital economy in no time with beleaf technologies
                  </p>
                  <Button
                    data-toggle="modal"
                    data-target="#myModal"
                    aria-label="Contact Us"
                    className="cbdc_button"
                  >
                    Lets Discuss
                  </Button>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="cbdc_bannersec_img">
                  <img
                    src={require("../../image/cbdc/cbdc_banner_img.webp")}
                    className=""
                    alt="Central Bank Digital Currency Development Company"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="cbdc_whatissec d-flex align-items-center bg-white">
          <div className="container">
            <div className="row justify-content-center align">
              <div className="col-lg-6 d-flex align-items-center">
                <div className="cbdc_bannersec_img">
                  <img
                    src={require("../../image/cbdc/cbdc_whatis_img.webp")}
                    className=""
                    alt="Central Bank Digital Currency Development Company"
                  />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="cbdc_whatissec_content d-flex flex-column ">
                  <h2 className="cbdc_h2 mb-0">
                    What is Central Bank
                    <br />
                    Digital Currency Development?
                  </h2>
                  <p className="mb-0 cbdc_p ">
                    Central Bank Digital Currency (CBDC) development refers to
                    the creation of a digital form of a country's official
                    currency by its central bank. Unlike cryptocurrencies, CBDCs
                    are centralized and typically issued and regulated by the
                    government.
                    <br />
                    <br />
                    This digital representation of traditional currency aims to
                    modernize financial systems, streamline transactions, and
                    provide a secure and efficient means of payment. CBDCs can
                    coexist with physical cash, offering citizens a digital
                    alternative for everyday transactions.
                    <br />
                    <br /> The development of CBDCs reflects a global shift
                    towards digital finance, with central banks exploring
                    innovative solutions to meet the evolving needs of the
                    modern economy.
                  </p>
                  <a href="https://wa.me/7904323274" className="">
                    <button className="cbdc_button">Talk To Our Experts</button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="cbdc_featuresec">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="cbdc_featuresec_title text-center">
                  <h2 className="cbdc_h2">
                    Features of Our
                    <br />
                    Central Bank Digital Currency Development
                  </h2>
                  <p className="cbdc_p">
                    Discover seamless transactions with our Central Bank Digital
                    Currency Development. Enjoy secure and instant payments,
                    user-friendly interfaces, and strong financial tracking with
                    premium features of our CBDC Development.
                  </p>
                </div>
              </div>
            </div>
            <div className="cbdc_featuresec_cardarea mt-5">
              <div className="row">
                <div className="col-lg-4 col-sm-6">
                  <div className="cbdc_featuresec_card d-flex">
                    <div className="cbdc_featuresec_card_img mr-3">
                      <i className="ri-settings-4-line"></i>
                    </div>
                    <div className="cbdc_featuresec_card_content">
                      <h3 className="cbdc_h3">Customization</h3>
                      <p className="cbdc_p">
                        Develop CBDC solutions to align with the unique
                        requirements and regulations of your country.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 displaynoneresp_ik"></div>
                <div className="col-lg-4 col-sm-6">
                  <div className="cbdc_featuresec_card d-flex">
                    <div className="cbdc_featuresec_card_content text-right">
                      <h3 className="cbdc_h3">Scalability</h3>
                      <p className="cbdc_p">
                        Our CBDC solutions are designed to scale seamlessly,
                        accommodating growing transaction volumes.
                      </p>
                    </div>
                    <div className="cbdc_featuresec_card_img ml-3">
                      <i className="ri-bar-chart-grouped-line"></i>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-sm-6">
                  <div className="cbdc_featuresec_card d-flex">
                    <div className="cbdc_featuresec_card_img mr-3">
                      <i className="ri-file-lock-line"></i>
                    </div>
                    <div className="cbdc_featuresec_card_content">
                      <h3 className="cbdc_h3">Smart Contract Integration</h3>
                      <p className="cbdc_p">
                        Utilize the power of smart contracts for automated and
                        secure transactions.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 displaynoneresp_ik">
                  <div className="cbdc_featuresec_cardarea_img">
                    <img
                      src={require("../../image/cbdc/cbdc_featuresec_img.webp")}
                      className=""
                      alt="Central Bank Digital Currency Development Company"
                    />
                  </div>
                </div>
                <div className="col-lg-4 col-sm-6">
                  <div className="cbdc_featuresec_card d-flex">
                    <div className="cbdc_featuresec_card_content text-right">
                      <h3 className="cbdc_h3">Interoperability</h3>
                      <p className="cbdc_p">
                        Ensure compatibility with existing financial systems for
                        a smooth transition to a digital economy.
                      </p>
                    </div>
                    <div className="cbdc_featuresec_card_img ml-3">
                      <i className="ri-links-line"></i>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-sm-6">
                  <div className="cbdc_featuresec_card d-flex">
                    <div className="cbdc_featuresec_card_img mr-3">
                      <i className="ri-device-line"></i>
                    </div>
                    <div className="cbdc_featuresec_card_content">
                      <h3 className="cbdc_h3">User-Friendly Interfaces</h3>
                      <p className="cbdc_p">
                        Intuitive interfaces make CBDC transactions accessible
                        to individuals with varying levels of technical
                        expertise.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 displaynoneresp_ik"></div>
                <div className="col-lg-4 col-sm-6">
                  <div className="cbdc_featuresec_card d-flex">
                    <div className="cbdc_featuresec_card_content text-right">
                      <h3 className="cbdc_h3">Regulatory Compliance</h3>
                      <p className="cbdc_p">
                        We prioritize adherence to regulatory frameworks,
                        ensuring a compliant and secure CBDC ecosystem.
                      </p>
                    </div>
                    <div className="cbdc_featuresec_card_img ml-3">
                      <i className="ri-shield-check-line"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="cbdc_whychoosesec bg-white ">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 d-flex align-items-center">
                <div className="cbdc_whychoosesec_content d-flex flex-column">
                  <h2 className="cbdc_h2 mb-0">
                    Why Choose Beleaf Technologies for Central Bank Digital
                    Currency Development?{" "}
                  </h2>
                  <p className="mb-0 cbdc_p ">
                    Choose Beleaf Technologies for Central Bank Digital Currency
                    (CBDC) development for unparalleled expertise and advanced
                    solutions.
                    <br />
                    <br />
                    With a proven track record in fintech, Beleaf combines
                    innovative technology with a deep understanding of
                    regulatory requirements to create Safe and secure CBDC
                    systems.
                    <br />
                    <br />
                    Our team of trained developers ensures seamless integration,
                    scalability, and adherence to the highest industry
                    standards.
                    <br />
                    <br />
                    Trust Beleaf for a crafted CBDC solution that not only meets
                    your current needs but also anticipates future challenges in
                    the ever-evolving landscape of digital currencies.
                    <br />
                    <br />
                    Take your financial infrastructure with Beleaf Technologies.
                  </p>
                  <button
                    data-toggle="modal"
                    data-target="#myModal"
                    className="cbdc_button"
                  >
                    Get Free Demo
                  </button>
                </div>
              </div>
              <div className="col-lg-6 d-flex align-items-center">
                <div className="cbdc_whychoosesec_img">
                  <img
                    src={require("../../image/cbdc/cbdc_whychoose_img.webp")}
                    className=""
                    alt="Central Bank Digital Currency Development Company"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="cbdc_benefitssec">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-12">
                <div className="cbdc_benefitssec_title text-center">
                  <h2 className="cbdc_h2 mb-2">
                    Benefits of
                    <br />
                    Central Bank Digital Currency Development
                  </h2>
                  <p className="cbdc_p mb-0">
                    Enjoy faster and more secure payments, reduced transaction
                    costs, and increased financial inclusion. Experience the
                    convenience of digital currency directly from your central
                    bank.
                  </p>
                </div>
              </div>
            </div>
            <div className="cbdc_benefitssec_cardarea mt-5">
              <Slider {...processes_feture}>
                <div className="slider_section">
                  <div className="row justify-content-center">
                    <div className="col-lg-4 d-flex col-sm-6">
                      <div className="cbdc_benefitssec_card d-flex flex-column align-items-center text-center">
                        <img
                          src={require("../../image/cbdc/financilinclusion.webp")}
                          className=""
                          alt="Central Bank Digital Currency Development Company"
                        />
                        <h3 className="cbdc_h3 mb-2 mb-0">
                          Financial Inclusion
                        </h3>
                        <p className="cbdc_card_p mb-0">
                          CBDCs can extend financial services to unbanked
                          populations, enabling economic inclusion.
                        </p>
                      </div>
                    </div>
                    <div className="col-lg-4 d-flex col-sm-6">
                      <div className="cbdc_benefitssec_card d-flex flex-column align-items-center text-center">
                        <img
                          src={require("../../image/cbdc/reducedtransaction.webp")}
                          className=""
                          alt="Central Bank Digital Currency Development Company"
                        />
                        <h3 className="cbdc_h3 mb-0">
                          Reduced Transaction Costs
                        </h3>
                        <p className="cbdc_card_p mb-0">
                          Digital transactions with CBDCs can significantly
                          reduce transaction costs for businesses and consumers.
                        </p>
                      </div>
                    </div>
                    <div className="col-lg-4 d-flex col-sm-6">
                      <div className="cbdc_benefitssec_card d-flex flex-column align-items-center text-center">
                        <img
                          src={require("../../image/cbdc/monetory.webp")}
                          className=""
                          alt="Central Bank Digital Currency Development Company"
                        />
                        <h3 className="cbdc_h3 mb-0">Monetary Policy Tools</h3>
                        <p className="cbdc_card_p mb-0">
                          CBDCs provide central banks with additional tools for
                          implementing monetary policies effectively.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="slider_section">
                  <div className="row justify-content-center">
                    <div className="col-lg-4 d-flex col-sm-6">
                      <div className="cbdc_benefitssec_card d-flex flex-column align-items-center text-center">
                        <img
                          src={require("../../image/cbdc/enhancedsecurity.webp")}
                          className=""
                          alt="Central Bank Digital Currency Development Company"
                        />
                        <h3 className="cbdc_h3 mb-0"> Enhanced Security</h3>
                        <p className="cbdc_card_p mb-0">
                          Built on advanced blockchain technology, CBDCs offer
                          strong security against fraud and counterfeiting.
                        </p>
                      </div>
                    </div>
                    <div className="col-lg-4 d-flex col-sm-6">
                      <div className="cbdc_benefitssec_card d-flex flex-column align-items-center text-center">
                        <img
                          src={require("../../image/cbdc/streamlined.webp")}
                          className=""
                          alt="Central Bank Digital Currency Development Company"
                        />
                        <h3 className="cbdc_h3 mb-0">
                          Streamlined Cross-Border Transactions
                        </h3>
                        <p className="cbdc_card_p mb-0">
                          {" "}
                          CBDCs facilitate faster and more transparent
                          cross-border transactions.
                        </p>
                      </div>
                    </div>
                    <div className="col-lg-4 d-flex col-sm-6">
                      <div className="cbdc_benefitssec_card d-flex flex-column align-items-center text-center">
                        <img
                          src={require("../../image/cbdc/adaptability.webp")}
                          className=""
                          alt="Central Bank Digital Currency Development Company"
                        />
                        <h3 className="cbdc_h3 mb-0"> Adaptability</h3>
                        <p className="cbdc_card_p mb-0">
                          CBDCs can evolve with technological advancements,
                          ensuring an adaptable and future-proof financial
                          system.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </Slider>
            </div>
          </div>
        </section>
        <section className="cbdc_startyoursec bg-white">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 d-flex align-items-center">
                <div className="cbdc_startyoursec_img">
                  <img
                    src={require("../../image/cbdc/cbdc_startyoursec_img.webp")}
                    className=""
                    alt="Central Bank Digital Currency Development Company"
                  />
                </div>
              </div>
              <div className="col-lg-6 d-flex align-items-center">
                <div className="cbdc_startyoursec_content d-flex flex-column">
                  <h2 className="cbdc_h2 mb-0">
                    Start Your Central Bank Digital Currency Development{" "}
                  </h2>
                  <p className="mb-0 cbdc_p ">
                    Begin your Central Bank Digital Currency (CBDC) development
                    with Beleaf Technologies. Our straightforward solutions make
                    crafting your digital currency easy and effective. Dive into
                    the world of digital finance innovation today! Contact us
                    today to initiate your CBDC development journey.
                  </p>
                  <button
                    data-toggle="modal"
                    data-target="#myModal"
                    className="cbdc_button"
                  >
                    Start Today
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="cbdc_revenuesec">
          <div className="container">
            <div className="row">
              <div className="col-lg-5">
                <div className="cbdc_revenuesec_title d-flex flex-column">
                  <h2 className="cbdc_h2 mb-0">
                    Revenue Factors of
                    <br />
                    our Central Bank Digital Currency Development
                  </h2>
                  <p className="mb-0 cbdc_p ">
                    Unlock financial possibilities with Beleaf Technologies
                    Central Bank Digital Currency development. Experience
                    increased revenue through seamless transactions, enhanced
                    security, and a future-ready digital economy.
                  </p>
                  <a href="https://wa.me/7904323274" className="">
                    <button className="cbdc_button">Talk To Our Experts</button>
                  </a>
                </div>
              </div>
              <div className="col-lg-7">
                <div className="cbdc_revenuesec_cardarea mt-5">
                  <div className="row">
                    <div className="col-lg-10">
                      {" "}
                      <div className="cbdc_revenuesec_card d-flex ">
                        <div className="cbdc_revenuesec_card_img mr-3">
                          <i className="ri-currency-line"></i>{" "}
                        </div>
                        <div className="cbdc_revenuesec_card_content">
                          <h3 className="cbdc_h3">Transaction Fees</h3>
                          <p className="cbdc_p">
                            {" "}
                            Generate revenue through minimal transaction fees
                            associated with CBDC transactions.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-2"></div>
                    <div className="col-lg-2"></div>
                    <div className="col-lg-10">
                      {" "}
                      <div className="cbdc_revenuesec_card d-flex ">
                        <div className="cbdc_revenuesec_card_img mr-3">
                          <i className="ri-customer-service-2-line"></i>{" "}
                        </div>
                        <div className="cbdc_revenuesec_card_content">
                          <h3 className="cbdc_h3">Consultation Services</h3>
                          <p className="cbdc_p">
                            {" "}
                            Offer consulting services to other nations embarking
                            on their CBDC development journey.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-10">
                      {" "}
                      <div className="cbdc_revenuesec_card d-flex ">
                        <div className="cbdc_revenuesec_card_img mr-3">
                          <i className="ri-hand-coin-line"></i>{" "}
                        </div>
                        <div className="cbdc_revenuesec_card_content">
                          <h3 className="cbdc_h3">Technology Licensing</h3>
                          <p className="cbdc_p">
                            Monetize your CBDC technology by licensing it to
                            other countries or financial institutions.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-2"></div>
                    <div className="col-lg-2"></div>
                    <div className="col-lg-10">
                      {" "}
                      <div className="cbdc_revenuesec_card d-flex ">
                        <div className="cbdc_revenuesec_card_img mr-3">
                          <i className="ri-link-m"></i>{" "}
                        </div>
                        <div className="cbdc_revenuesec_card_content">
                          <h3 className="cbdc_h3">Integration Services</h3>
                          <p className="cbdc_p">
                            Provide integration services for businesses adapting
                            their systems to incorporate CBDC transactions.
                          </p>
                        </div>
                      </div>{" "}
                    </div>
                    <div className="col-lg-10">
                      {" "}
                      <div className="cbdc_revenuesec_card d-flex ">
                        <div className="cbdc_revenuesec_card_img mr-3">
                          <i className="ri-file-lock-line"></i>{" "}
                        </div>
                        <div className="cbdc_revenuesec_card_content">
                          <h3 className="cbdc_h3">
                            Smart Contract Development
                          </h3>
                          <p className="cbdc_p">
                            Generate revenue by developing customized smart
                            contracts developed to specific use cases.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="cbdc_takewaysec bg-white ">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 d-flex align-items-center">
                <div className="cbdc_takewaysec_content d-flex flex-column">
                  <h2 className="cbdc_h2 mb-0">Take Away </h2>
                  <p className="mb-0 cbdc_p ">
                    Central Bank Digital Currency Development is not just an
                    option; it's a necessity. Beleaf Technologies combines
                    expertise, innovation, and reliability to pave the way for a
                    digital future that's secure, inclusive, and efficient.
                  </p>
                  <button
                    data-toggle="modal"
                    data-target="#myModal"
                    className="cbdc_button"
                  >
                    Let's Discuss
                  </button>
                </div>
              </div>
              <div className="col-lg-6 d-flex align-items-center">
                <div className="cbdc_takewaysec_img">
                  <img
                    src={require("../../image/cbdc/cbdc_takeaway_img.webp")}
                    className=""
                    alt="Central Bank Digital Currency Development Company"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="cbdc_faq paddng_100">
          <Section id="about why new_faq bg_white CEX_faq">
            <section className="section bg_white CEX_faq" id="">
              <div className="container">
                <div className="row">
                  <div className="col-lg-6 d-flex align-items-center justify-content-center">
                    <div className="whybelaf faq">
                      <h2 className="">
                        Frequently asked <br />
                        Question
                      </h2>
                      <p></p>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="comtent">
                      <div id="main" className="mt-0">
                        <div className="container">
                          <div className="accordion" id="faq">
                            <div className="card">
                              <div className="card-header" id="faqhead1">
                                <a
                                  href="#"
                                  className="btn btn-header-link w-100"
                                  data-toggle="collapse"
                                  data-target="#faq1"
                                  aria-expanded="true"
                                  aria-controls="faq1"
                                >
                                  How long does it take to develop a CBDC with
                                  Beleaf Technologies?
                                </a>
                              </div>

                              <div
                                id="faq1"
                                className="collapse show"
                                aria-labelledby="faqhead1"
                                data-parent="#faq"
                              >
                                <div className="card-body">
                                  The development timeline varies based on the
                                  specific requirements of your country. Our
                                  team ensures an agile and efficient process.
                                </div>
                              </div>
                            </div>
                            <div className="card">
                              <div className="card-header" id="faqhead2">
                                <a
                                  href="#"
                                  className="btn btn-header-link w-100 collapsed"
                                  data-toggle="collapse"
                                  data-target="#faq2"
                                  aria-expanded="true"
                                  aria-controls="faq2"
                                >
                                  How secure are CBDC transactions developed by
                                  Beleaf Technologies?{" "}
                                </a>
                              </div>

                              <div
                                id="faq2"
                                className="collapse"
                                aria-labelledby="faqhead2"
                                data-parent="#faq"
                              >
                                <div className="card-body">
                                  Security is paramount in our development
                                  process. We employ state-of-the-art encryption
                                  and blockchain technology to ensure the
                                  integrity of CBDC transactions.
                                </div>
                              </div>
                            </div>
                            <div className="card">
                              <div className="card-header" id="faqhead3">
                                <a
                                  href="#"
                                  className="btn btn-header-link w-100 collapsed"
                                  data-toggle="collapse"
                                  data-target="#faq3"
                                  aria-expanded="true"
                                  aria-controls="faq3"
                                >
                                  Can CBDCs coexist with traditional currencies?
                                </a>
                              </div>

                              <div
                                id="faq3"
                                className="collapse"
                                aria-labelledby="faqhead3"
                                data-parent="#faq"
                              >
                                <div className="card-body">
                                  Absolutely. CBDCs are designed to complement
                                  traditional currencies, offering a digital
                                  alternative without replacing physical cash.
                                </div>
                              </div>
                            </div>
                            <div className="card">
                              <div className="card-header" id="faqhead4">
                                <a
                                  href="#"
                                  className="btn btn-header-link w-100 collapsed"
                                  data-toggle="collapse"
                                  data-target="#faq4"
                                  aria-expanded="true"
                                  aria-controls="faq4"
                                >
                                  What regulatory considerations should be taken
                                  into account during CBDC development?
                                </a>
                              </div>

                              <div
                                id="faq4"
                                className="collapse"
                                aria-labelledby="faqhead4"
                                data-parent="#faq"
                              >
                                <div className="card-body">
                                  Our experts ensure strict adherence to
                                  regulatory frameworks, working closely with
                                  central banks to meet all legal requirements.
                                </div>
                              </div>
                            </div>
                            <div className="card">
                              <div className="card-header" id="faqhead5">
                                <a
                                  href="#"
                                  className="btn btn-header-link w-100 collapsed"
                                  data-toggle="collapse"
                                  data-target="#faq5"
                                  aria-expanded="true"
                                  aria-controls="faq5"
                                >
                                  How does CBDC development contribute to
                                  economic growth
                                </a>
                              </div>

                              <div
                                id="faq5"
                                className="collapse"
                                aria-labelledby="faqhead5"
                                data-parent="#faq"
                              >
                                <div className="card-body">
                                  CBDCs can stimulate economic growth by
                                  reducing transaction costs, increasing
                                  financial inclusion, and providing central
                                  banks with effective monetary policy tools.
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </Section>
        </section>
      </main>
      {/* <Footer /> */}
      <ServiceFooter />
    </main>
  );
}

export default Cex;
